import React from "react";
import {Form, Input, Radio, Select,Alert} from 'antd';
import NHFetch from "../../../utils/NHFetch";
import NHFormItem from '../../common/NHFormItem';

const FormItem = Form.Item;

const baseUrlPath = "/fwwgl/cjwt"; //学校信息管理模块路径

/**
 * 在线问答编辑表单
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class SettingInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            wtfllist:[],//问题分类list
            wtlxlist:[],//问题类型list
        }
    }

    componentWillMount(){
        this.wtflload();
        this.wtlxload();
    }

    //渲染问题分类
    wtflload = ()=>{
        NHFetch("/proData/selectDataList","get",'sign=dmk_YXXT_WTFL')
            .then(res => {
                this.setState({wtfllist:res.data});
            });
    };

    //渲染问题类型
    wtlxload = ()=>{
        NHFetch("/proData/selectDataList","get",'sign=dmk_YXXT_WTLX')
            .then(res => {
                this.setState({wtlxlist:res.data});
            });
    };



    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        const initFormData = this.props.initFormData;

        const {wtfllist,wtlxlist} = this.state;
        let wtfls = [];
        if(wtfllist) {
            wtfls = wtfllist.map((item,index) => <Select.Option key={index} value={item.VALUE}>{item.LABEL}</Select.Option>);
        }

        let wtlxs = [];
        if(wtlxlist) {
            wtlxs = wtlxlist.map((item,index) => <Select.Option key={index} value={item.VALUE}>{item.LABEL}</Select.Option>);
        }

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem formItemLayout={{labelCol: { xs: { span: 24 },sm: { span: 8 }}}} form={this.props.form}>
                        <Alert  message={"普通问题：只能该学生可以查看，常见问题：所有学生可以查看"} />
                    </NHFormItem>
                    <div style={{display:'none'}}>
                    <NHFormItem id={"pkid"} label={"主键"}
                                form={this.props.form} initialValue={initFormData.pkid}>
                                <input />
                    </NHFormItem>
                    </div>
                    <NHFormItem id={"wtlx"} label={"问题类型"}
                                form={this.props.form} initialValue={initFormData.wtlx}>
                                <Select placeholder= '请选择...'>
                                    <Select.Option value=''>请选择...</Select.Option>
                                    {wtlxs}
                                </Select>
                    </NHFormItem>
                    <NHFormItem id={"wtfl"} label={"问题分类"}
                                form={this.props.form} initialValue={initFormData.wtfl}>
                                <Select placeholder= '请选择...'>
                                    <Select.Option value=''>请选择...</Select.Option>
                                    {wtfls}
                                </Select>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const SettingForm = Form.create()(SettingInitForm);

export default SettingForm;


// WEBPACK FOOTER //
// ./components/fwwgl/zxwd/SettingForm.js